<template>
  <div class="hide-scroll">
    <v-row>
      <v-col cols="4" class="pl-0">
        <v-autocomplete
          :items="clients"
          label="Selecteer een klant"
          item-text="name"
          item-value="id"
          hide-details
          v-model="selectedClient"
          single-line
          outlined
          dense
        ></v-autocomplete>
      </v-col>
      <v-col cols="4" v-if="selectedClient">
        <v-layout justify-center align-center fill-height>
          <p class="text-h5">
            Totaal punten:
            <span class="text-h4 font-weight-bold">{{
              clientProps.Data.Number.Value
            }}</span>
          </p>
        </v-layout>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-card outlined elevation="0" v-if="selectedClient" class="mt-4">
      <v-row>
        <v-col cols="4">Datum</v-col>
        <v-col cols="4">Type</v-col>
        <v-col cols="4">Points</v-col>
      </v-row>
      <v-card elevation="0">
        <v-row class="pr-4">
          <v-col cols="2" class="py-0">
            <v-menu min-width="auto">
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="pa-0"
                  hide-details
                  v-on="on"
                  :value="newItem.pickedDate"
                  outlined
                  dense
                  label="Datum"
                  slot="activator"
                ></v-text-field>
              </template>

              <v-date-picker v-model="newItem.pickedDate"></v-date-picker>
            </v-menu>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="2" class="py-0">
            <v-select
              hide-details
              class="pa-0 pl-2"
              :items="types"
              item-text="name"
              item-value="id"
              v-model="newItem.type"
              outlined
              dense
              label="Type"
            >
            </v-select>
          </v-col>
          <v-spacer></v-spacer>

          <v-col cols="2" class="py-0">
            <v-text-field
              class="pa-0 pl-2"
              hide-details
              type="number"
              v-model="newItem.points"
              outlined
              dense
              label="Punten"
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="py-0">
            <v-layout justify-end align-center>
              <v-btn
                elevation="0"
                fab
                small
                color="primary"
                class="mr-4"
                :disabled="
                  newItem.points != undefined &&
                  newItem.type &&
                  newItem.pickedDate
                    ? false
                    : true
                "
                @click="addNewItem()"
              >
                <v-icon> mdi-plus </v-icon>
              </v-btn>
            </v-layout>
          </v-col>
        </v-row>
      </v-card>
      <v-row class="mt-4">
        <v-virtual-scroll
          :items="history"
          height="500"
          item-height="60"
          @scroll.native="handleScroll"
        >
          <template v-slot:default="{ item, index }">
            <v-list-item>
              <v-list-item-content>
                <v-row class="">
                  <v-col cols="2" class="pl-0 py-0">
                    <v-layout fill-height align-center>
                      {{ getFormattedDate(new Date(item.Date.$date)) }}
                    </v-layout>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2" class="pl-6 py-0">
                    <v-layout fill-height align-center>
                      {{ types.find((el) => el.id == item.TypeId.$oid).name }}
                    </v-layout>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2" class="pl-6 py-0">
                    <v-layout fill-height align-center>
                      {{ item.Points }}
                    </v-layout>
                  </v-col>
                  <v-col cols="2" class="pl-6 py-0">
                    <v-layout justify-end align-center>
                      <v-dialog v-model="dialog[index]" width="800">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            color="warning"
                            elevation="0"
                            icon
                            v-on="on"
                            @click="prepEditItem(item)"
                          >
                            <v-icon> mdi-pencil </v-icon>
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title>
                            <span class="text-h5">Aanpassen</span>
                          </v-card-title>
                          <v-card-text>
                            <v-container>
                              <v-row>
                                <v-col cols="4">
                                  <v-menu min-width="auto">
                                    <template v-slot:activator="{ on }">
                                      <v-text-field
                                        class="pa-0"
                                        hide-details
                                        v-on="on"
                                        :value="editableDate"
                                        outlined
                                        dense
                                        label="Datum"
                                        slot="activator"
                                        required
                                      ></v-text-field>
                                    </template>

                                    <v-date-picker
                                      v-model="editableDate"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-col>

                                <v-col cols="4">
                                  <v-select
                                    required
                                    hide-details
                                    class="pa-0"
                                    :items="types"
                                    item-text="name"
                                    item-value="id"
                                    v-model="item.TypeId.$oid"
                                    outlined
                                    dense
                                    label="Type"
                                  ></v-select>
                                </v-col>
                                <v-col cols="4">
                                  <v-text-field
                                    class="pa-0"
                                    hide-details
                                    type="number"
                                    v-model="item.Points"
                                    outlined
                                    dense
                                    label="Punten"
                                    required
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary darken-1"
                              text
                              @click="dialog[index] = false"
                            >
                              Sluiten
                            </v-btn>
                            <v-btn
                              color="primary darken-1"
                              text
                              @click="editItem(index, item)"
                            >
                              Opslaan
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="deleteDialog[index]" width="800">
                        <template v-slot:activator="{ on }">
                          <v-btn color="error" elevation="0" icon v-on="on">
                            <v-icon> mdi-delete </v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title class="text-h5">
                            Verwijderen
                          </v-card-title>

                          <v-card-text>
                            Ben je zeker dat je dit item wil verwijderen?
                          </v-card-text>

                          <v-divider></v-divider>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="primary"
                              text
                              @click="deleteDialog[index] = false"
                            >
                              Nee
                            </v-btn>
                            <v-btn
                              color="primary"
                              text
                              @click="deleteItem(index)"
                            >
                              Ja
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-layout>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>
      </v-row>
    </v-card>
    <v-card outlined v-else>
      <v-card-text>
        Geen klant geselecteerd
      </v-card-text>
    </v-card>
  </div>
</template>
  
  <script>
import helpers from "@/helpers";
export default {
  data() {
    return {
      dialog: {},
      deleteDialog: {},
      selectedClient: null,
      clientProps: null,
      startScroll: 0,
      countScroll: 10,
      newItem: {
        type: "",
        points: 0,
        pickedDate: null,
      },
      editableDate: null,
      clients: [],
      history: [],
      maxItems: 0,
      points: [
        {
          _id: { $oid: "634665f610240c72067f3670" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 330,
          Date: { $date: 1664496000000 },
          Reference: "VER-2022-202941",
        },
        {
          _id: { $oid: "634665f610240c72067f366f" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 2425,
          Date: { $date: 1664496000000 },
          Reference: "VER-2022-202940",
        },
        {
          _id: { $oid: "634665f610240c72067f35f0" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 767,
          Date: { $date: 1664150400000 },
          Reference: "VER-2022-202642",
        },
        {
          _id: { $oid: "634665f610240c72067f35f1" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 598,
          Date: { $date: 1664150400000 },
          Reference: "VER-2022-202643",
        },
        {
          _id: { $oid: "634665f610240c72067f35f2" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 309,
          Date: { $date: 1664150400000 },
          Reference: "VER-2022-202644",
        },
        {
          _id: { $oid: "633d2b78701969ccd79c88e6" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 1360,
          Date: { $date: 1663545600000 },
          Reference: "VER-2022-202362",
        },
        {
          _id: { $oid: "633d2b78701969ccd79c88e8" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 72,
          Date: { $date: 1663545600000 },
          Reference: "VER-2022-202364",
        },
        {
          _id: { $oid: "633d2b78701969ccd79c88e7" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 69,
          Date: { $date: 1663545600000 },
          Reference: "VER-2022-202363",
        },
        {
          _id: { $oid: "6333f0f6d301066b101b7e9a" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 2315,
          Date: { $date: 1662940800000 },
          Reference: "VER-2022-202080",
        },
        {
          _id: { $oid: "6333f0f6d301066b101b7e9b" },
          CustomerId: { $oid: "61b9b717ff3cda26d627be56" },
          TypeId: { $oid: "618a88451b54be347afaf4d4" },
          Points: 22,
          Date: { $date: 1662940800000 },
          Reference: "VER-2022-202081",
        },
      ],
      users: [
        {
          _id: { $oid: "632ab673ed62705a5772cb54" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 354,
          DisplayLabel: "21489, DECATOM Comm.V, decaesstecker.tom@gmail.com",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 21489,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "DECATOM Comm.V", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "decaesstecker.tom@gmail.com", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 401,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1664953246506 },
        },
        {
          _id: { $oid: "632ab674ed62705a5772cb55" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 355,
          DisplayLabel:
            "21492, HIMPE STEVEN ELEKTRICITEITSWERKEN, info@elektriciteitswerkensteven.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 21492,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: {
                Nl: "HIMPE STEVEN ELEKTRICITEITSWERKEN",
                Fr: "",
                En: "",
              },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: {
                Nl: "info@elektriciteitswerkensteven.be",
                Fr: "",
                En: "",
              },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 67206,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041014 },
        },
        {
          _id: { $oid: "632ab674ed62705a5772cb56" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 356,
          DisplayLabel: "1549, Waids Stefaan & Caroll, stefaanwaids@skynet.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 1549,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "Waids Stefaan & Caroll", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "stefaanwaids@skynet.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 340,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558004043 },
        },
        {
          _id: { $oid: "6333f0f3d301066b101b7e69" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 357,
          DisplayLabel: "18370, VANDERSARREN BART, bart@b-fix-t.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 18370,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "VANDERSARREN BART", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "bart@b-fix-t.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 497,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1664953246534 },
        },
        {
          _id: { $oid: "6333f0f3d301066b101b7e6a" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 358,
          DisplayLabel: "10689, PERSYN ELEKTRO, mathiaspersyn@hotmail.com",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 10689,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "PERSYN ELEKTRO", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "mathiaspersyn@hotmail.com", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 1054,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041051 },
        },
        {
          _id: { $oid: "6333f0f3d301066b101b7e6b" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 359,
          DisplayLabel: "355, STAELENS-ELECTRONICA, staelens.bvba@telenet.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 355,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "STAELENS-ELECTRONICA", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "staelens.bvba@telenet.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 340,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041061 },
        },
        {
          _id: { $oid: "6333f0f3d301066b101b7e6c" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 360,
          DisplayLabel: "15567, SOUBRY KURT, kurtsoubry2603@gmail.com",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 15567,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "SOUBRY KURT", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "kurtsoubry2603@gmail.com", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 530,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041081 },
        },
        {
          _id: { $oid: "633d2b77701969ccd79c88b7" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 361,
          DisplayLabel:
            "21512, VME Residentie Hogerlucht, laura@aenvconsulting.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 21512,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "VME Residentie Hogerlucht", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "laura@aenvconsulting.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 424,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041071 },
        },
        {
          _id: { $oid: "633d2b77701969ccd79c88b8" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 362,
          DisplayLabel: "21513, ROTARESCU DAN, info@fimconstruct.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 21513,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "ROTARESCU DAN", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "info@fimconstruct.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 8937,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041100 },
        },
        {
          _id: { $oid: "633d2b77701969ccd79c88b9" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 363,
          DisplayLabel: "19686, 100% LIGHT BVBA, ",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 19686,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "100% LIGHT BVBA", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 421,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041110 },
        },
        {
          _id: { $oid: "634665f310240c72067f35ba" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 364,
          DisplayLabel:
            "21202, Himpe Steven Elektriciteitswerken NIET MEER GEBRUIKEN, info@elektriciteitswerkensteven.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 21202,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: {
                Nl: "Himpe Steven Elektriciteitswerken NIET MEER GEBRUIKEN",
                Fr: "",
                En: "",
              },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: {
                Nl: "info@elektriciteitswerkensteven.be",
                Fr: "",
                En: "",
              },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 333,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041039 },
        },
        {
          _id: { $oid: "634665f310240c72067f35bb" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 365,
          DisplayLabel: "558, DITRA NV, guidoderprez@skynet.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 558,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "DITRA NV", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "guidoderprez@skynet.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 173,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041119 },
        },
        {
          _id: { $oid: "634665f310240c72067f35bc" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 366,
          DisplayLabel:
            "21534, VENTELEK BVBA (tack steven), info@steventack.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 21534,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "VENTELEK BVBA (tack steven)", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "info@steventack.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 1177,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041129 },
        },
        {
          _id: { $oid: "634665f310240c72067f35bd" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 367,
          DisplayLabel: "20725, Meersschaert, Robby, info@rmginterieur.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 20725,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "Meersschaert, Robby", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "info@rmginterieur.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: 285,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558041149 },
        },
        {
          _id: { $oid: "634665f310240c72067f35be" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 368,
          DisplayLabel: "3980, STAD KORTRIJK, luc.demonie@kortrijk.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 3980,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "STAD KORTRIJK", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "luc.demonie@kortrijk.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: "",
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558003849 },
        },
        {
          _id: { $oid: "634665f310240c72067f35bf" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 369,
          DisplayLabel: "20237, Bulcaen Kurt, info@electrobulcaen.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 20237,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "Bulcaen Kurt", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "info@electrobulcaen.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: "",
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558003861 },
        },
        {
          _id: { $oid: "634665f310240c72067f35c0" },
          PageId: { $oid: "618a4f962f1b33c8c020be51" },
          WebsiteId: { $oid: "61596b5095902d1211891e13" },
          Sort: 370,
          DisplayLabel: "20981, VANDEWEEGE BRAM, sylvain.vercruysse@live.be",
          Data: {
            Number: {
              Title: "Nummer",
              Value: 20981,
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            Name: {
              Title: "Naam",
              Value: { Nl: "VANDEWEEGE BRAM", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Email: {
              Title: "E-mailadres",
              Value: { Nl: "sylvain.vercruysse@live.be", Fr: "", En: "" },
              Type: "text",
              Translate: false,
              Options: [],
              Properties: [],
              Required: false,
              AddToTableView: true,
            },
            Active: {
              Title: "Actief",
              Value: true,
              Type: "boolean",
              Translate: true,
              Options: [],
              Properties: [],
              AddToTableView: true,
            },
            TotalPointsPreviousEmail: {
              Title: "Totaal aantal punten in vorige e-mail",
              Value: "",
              Type: "number",
              Translate: true,
              Options: [],
              Properties: [],
              ReadOnly: false,
            },
          },
          LinkedContentId: { $oid: "000000000000000000000000" },
          LastUpdated: { $date: 1665558003873 },
        },
      ],
      types: [
        { id: "618a88451b54be347afaf4d4", name: "Demo type" },
        { id: "618a88451b54be347afaf4d8", name: "Demo type 2" },
      ],
    };
  },
  watch: {
    selectedClient: function (val) {
      this.startScroll = 0;
      this.history = [];
      this.points.forEach((element) => {
        this.$set(this.history, this.history.length, element);
      });
      this.clientProps = this.users.find((el) => el._id.$oid == val);
    },
    "newItem.type": function (val) {
      const type = this.types.find((item) => item.id === val);
      if (type) {
        this.newItem.points = type.value;
      }
    },
  },

  created() {
    this.users.forEach((el) => {
      this.clients.push({ name: el.Data.Name.Value.Nl, id: el._id.$oid });
    });
  },

  methods: {
    handleScroll(event) {
      const element = event.currentTarget || event.target;
      if (
        element &&
        element.scrollHeight - element.scrollTop === element.clientHeight &&
        this.maxItems > this.startScroll
      ) {
        this.startScroll += 10;
      }
    },

    addNewItem() {
      if (
        this.newItem.pickedDate &&
        this.newItem.type &&
        this.newItem.points != undefined
      ) {
        this.$set(this.history, this.history.length, {
          CustomerId: { $oid: this.selectedClient.id },
          TypeId: { $oid: this.newItem.type },
          Points: this.newItem.points,
          Date: { $date: new Date(this.newItem.pickedDate) },
        });
      }
      this.clientProps.Data.Number.Value += Number(this.newItem.points);
      this.newItem = {
        type: "",
        points: 0,
        pickedDate: null,
      };
    },
    prepEditItem(item) {
      this.editableDate = helpers.changeTimeToReadebleDMY(item.Date.$date);
    },
    editItem(index, item) {
      this.$set(this.history, index, {
        CustomerId: { $oid: item.CustomerId.$oid },
        TypeId: { $oid: item.TypeId.$oid },
        Points: item.Points,
        Date: { $date: this.editableDate },
      });
      this.dialog[index] = false;
    },
    changeDate(date) {
      return new Date(date).toISOString().substr(0, 10);
    },
    deleteItem(index) {
      this.deleteDialog[index] = false;
      if (0 < this.clientProps.Data.Number.Value - this.history[index].Points) {
        this.clientProps.Data.Number.Value -= this.history[index].Points;
      }
      this.$delete(this.history, index);
    },
    getFormattedDate(date) {
      let year = date.getFullYear();
      let month = (1 + date.getMonth()).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");

      return day + "/" + month + "/" + year;
    },
  },
};
</script>
  
  <style>
</style>